import React, { useEffect, useState } from 'react';
import './Bumpups.css';
import { getHistory } from '../../utils/cookieManager';

const Bumpups = ({ updateTrigger }) => {
  const [history, setHistory] = useState([]);
  const [selectedResult, setSelectedResult] = useState(null);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const savedHistory = getHistory();
    if (savedHistory) {
      setHistory(savedHistory);
    }
  }, [updateTrigger]);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [showModal]);

  const handleViewTimestamps = (item) => {
    setSelectedResult(item.result);
    setSelectedVideoId(item.videoId);
    setShowModal(true);
  };

  const copyToClipboard = () => {
    if (!selectedResult) return;

    let textToCopy = '';
    if (selectedResult.timestamps_string) {
      textToCopy = selectedResult.timestamps_string;
    } else if (Array.isArray(selectedResult.timestamps_list)) {
      textToCopy = selectedResult.timestamps_list.join('\n');
    } else if (typeof selectedResult.output === 'string') {
      textToCopy = selectedResult.output;
    }

    navigator.clipboard.writeText(textToCopy).then(() => {
      alert('Timestamps copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  };

  const timeToSeconds = (timeStr) => {
    const parts = timeStr.split(':').reverse();
    let seconds = 0;
    for (let i = 0; i < parts.length; i++) {
      seconds += parseInt(parts[i], 10) * Math.pow(60, i);
    }
    return seconds;
  };

  const renderTimestamps = () => {
    if (!selectedResult) return null;

    let timestamps = [];
    if (Array.isArray(selectedResult.timestamps_list)) {
      timestamps = selectedResult.timestamps_list;
    } else if (typeof selectedResult.timestamps_string === 'string') {
      timestamps = selectedResult.timestamps_string.split('\n').filter(line => line.trim() !== '');
    } else if (typeof selectedResult.output === 'string') {
      timestamps = selectedResult.output.split('\n').filter(line => line.trim() !== '');
    }

    return timestamps.map((line, index) => {
      const match = line.match(/^(\d+:\d+(?::\d+)?)\s*[-–]\s*(.*)$/);
      if (match) {
        const seconds = timeToSeconds(match[1]);
        const link = selectedVideoId ? `https://youtu.be/${selectedVideoId}?t=${seconds}` : '#';
        return (
          <div key={index} className="timestamp-item">
            <a href={link} target="_blank" rel="noopener noreferrer" className="timestamp-time">{match[1]}</a>
            <span className="timestamp-text">{match[2]}</span>
          </div>
        );
      }
      return (
        <div key={index} className="timestamp-item">
          <span className="timestamp-text">{line}</span>
        </div>
      );
    });
  };

  return (
    <section className="bumpups">
      <div className="bumpups-header">
        <h2 className="bumpups-title">History</h2>
      </div>

      {history.length === 0 ? (
        <div className="empty-history">
          <p className="bumpups-subtitle">
            Your recent generated timestamps will appear here.
          </p>
        </div>
      ) : (
        <div className="history-grid">
          {history.map((item, index) => (
            <div key={index} className="history-card" onClick={() => handleViewTimestamps(item)}>
              <div className="card-header">
                <h3 className="history-video-title">{item.title}</h3>
                <span className="history-date">{item.date}</span>
              </div>

              <div className="card-body">
                <div className="thumbnail-wrapper">
                  <img
                    src={`https://img.youtube.com/vi/${item.videoId}/mqdefault.jpg`}
                    alt={item.title}
                    className="history-thumbnail"
                  />
                </div>
              </div>

              <div className="card-footer">
                <button className="view-timestamps-link">
                  <span className="link-text">View Timestamps</span>
                  <span className="link-arrow">↗</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && selectedResult && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Timestamps</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
            </div>

            <div className="modal-body">
              <div className="timestamp-list">
                {renderTimestamps()}
              </div>

              <div className="copy-btn-wrapper">
                <button className="copy-btn" onClick={copyToClipboard}>
                  📋 Copy
                </button>
              </div>
            </div>

            <div className="modal-footer">
              Get uninterrupted, priority service — AI Creator Studio, local video uploads, and more at <a href="https://bumpups.com" target="_blank" rel="noopener noreferrer">bumpups.com</a>.
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Bumpups;


